import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * https://github.com/dcastil/tailwind-merge/issues/326#issuecomment-1780721267
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: [
        'none',
        'xxs',
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        '2xl',
        '3xl',
        '4xl',
        '5xl',
        '6xl',
        '7xl',
        '8xl',
        '9xl',
        '10xl',
        '11xl',
      ],
      borderRadius: [
        'none',
        'xxs',
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        '2xl',
        '3xl',
        '4xl',
        '5xl',
        'full',
      ],
    },
    classGroups: {
      // @ts-expect-error -- custom typography classes
      typography: [
        'display-2xl',
        'display-xl',
        'display-lg',
        'display-md',
        'display-sm',
        'display-xs',
        'text-xl',
        'text-lg',
        'text-md',
        'text-sm',
        'text-xs',
        'text-xxs',
        'text-xxxs',
        'text-code',
      ],
      'font-size': [{ text: ['xxs', 'xxxs'] }],
      gap: ['gap-xxs', 'gap-xs', 'gap-sm', 'gap-md', 'gap-lg', 'gap-xl', 'gap-2xl', 'gap-3xl'],
      padding: ['pb-xxs', 'pb-xs', 'pb-sm', 'pb-md', 'pb-lg', 'pb-xl', 'pb-2xl', 'pb-3xl'],
    },
  },
});

/**
 * This function is used to merge tailwind classes.
 * If you just want to concatenate classes, use clsx instead
 */
export function slowCn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
